import { render, staticRenderFns } from "./Sites.vue?vue&type=template&id=0b8c5b7a&"
import script from "./Sites.vue?vue&type=script&lang=js&"
export * from "./Sites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8c5b7a')) {
      api.createRecord('0b8c5b7a', component.options)
    } else {
      api.reload('0b8c5b7a', component.options)
    }
    module.hot.accept("./Sites.vue?vue&type=template&id=0b8c5b7a&", function () {
      api.rerender('0b8c5b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/sites/Sites.vue"
export default component.exports